import React from 'react'

import { Box, Flex, Icon, Link, Text } from '@driftt/dds'
import { faCirclePlay } from '@driftt/dds.icons/light/faCirclePlay'
import { faEye } from '@driftt/dds.icons/light/faEye'

interface VideoContentProps {
  url?: string
  title?: string
  thumbnailUrl?: string
  percentViewed?: number
  trackAction: (action: string, additionalData?: any) => void
}

export const VideoContent = ({
  url,
  title,
  thumbnailUrl,
  percentViewed,
  trackAction
}: VideoContentProps) => {
  return (
    <Flex direction="column" css={{ paddingTop: '16px' }} gap={0}>
      {thumbnailUrl ? (
        <Link
          href={url}
          target="_blank"
          onClick={() => trackAction('Video link click', { percentViewed })}
          css={{
            textDecorationColor: '$white!important'
          }}>
          <Box
            css={{
              backgroundImage: `url(${thumbnailUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              width: '238px',
              height: '132px',
              borderRadius: '6px'
            }}>
            <Flex
              alignItems="center"
              justifyContent="center"
              direction="column"
              css={{
                backgroundColor: 'rgba(29, 34, 38, 0.4)',
                width: '100%',
                height: '100%',
                borderRadius: '6px'
              }}>
              <Icon icon={faCirclePlay} size="extra-large" color="white" />
            </Flex>
            {title && (
              <Text
                variant="bodyBold"
                css={{
                  color: '$white',
                  position: 'relative',
                  top: '-24px',
                  left: '8px',
                  width: '222px'
                }}
                truncate>
                {title}
              </Text>
            )}
          </Box>
        </Link>
      ) : (
        <Link
          href={url}
          target="_blank"
          onClick={() => trackAction('Video link click', { percentViewed })}
          css={{ color: '$gray12', textDecoration: 'underline' }}
          truncate>
          {title ?? url}
        </Link>
      )}
      {percentViewed !== undefined && (
        <Text variant="metadata" css={{ marginTop: '8px' }}>
          <Flex alignItems="center">
            <Icon icon={faEye} />
            {`${percentViewed < 0 ? 0 : percentViewed}%`}
          </Flex>
        </Text>
      )}
    </Flex>
  )
}
